import Deliverytime from './deliverytime';

export default Deliverytime;
